export default {
    tsolde: 0,
    tencours_nd: 0,
    tencours_d: 0,
    tdepasse1: 0,
    tdepasse2: 0,
    tdepasse3: 0,
    tdepasse4: 0,
    tcontent: 0,
    pay_outstanding: [],
    form_cb_outstanding_ref: Object(),
    outstanding_amount: 0,
    outstanding_pay: 0,
    ref: '',
    different_currency: false,
    selected_currency: []
};